/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * User's unread notification count
 * @export
 * @interface UserUnreadCountResponse
 */
export interface UserUnreadCountResponse {
    /**
     * Number of unread notifications
     * @type {number}
     * @memberof UserUnreadCountResponse
     */
    unreadCount: number;
}

/**
 * Check if a given object implements the UserUnreadCountResponse interface.
 */
export function instanceOfUserUnreadCountResponse(value: object): value is UserUnreadCountResponse {
    if (!('unreadCount' in value) || value['unreadCount'] === undefined) return false;
    return true;
}

export function UserUnreadCountResponseFromJSON(json: any): UserUnreadCountResponse {
    return UserUnreadCountResponseFromJSONTyped(json, false);
}

export function UserUnreadCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserUnreadCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'unreadCount': json['unreadCount'],
    };
}

export function UserUnreadCountResponseToJSON(json: any): UserUnreadCountResponse {
    return UserUnreadCountResponseToJSONTyped(json, false);
}

export function UserUnreadCountResponseToJSONTyped(value?: UserUnreadCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'unreadCount': value['unreadCount'],
    };
}

